'use strict';

bbw.service.RetinaDetectorSvc = Class({

    $inject: ['$window'],

    $window: undefined,

    construct: function($window) {
        this.$window = $window;
    },

    isRetina: function() {
        var mediaQuery = "(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), " +
            "(-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)";
        if (this.$window.devicePixelRatio > 1) {
            return true;
        }
        return (this.$window.matchMedia && this.$window.matchMedia(mediaQuery).matches);
    }

});

